import React from 'react';
import './Table.scss';

export type MidTitle = {
  colspan: number;
  title: string;
};

export type HeaderRow = {
  columns: (string | React.ReactNode)[];
};

export type TableRow = {
  columns: (string | React.ReactNode | MidTitle)[];
};

export type TableProps = {
  id: string;
  title?: string;
  header?: HeaderRow;
  rows: TableRow[];
  addendum?: string;
};

const Table = ({
  id,
  title,
  header,
  rows,
  addendum
}: TableProps): JSX.Element => {
  const isMidTitle = (
    column: string | React.ReactNode | MidTitle
  ): column is MidTitle => {
    if ((column as MidTitle).colspan) {
      return true;
    }
    return false;
  };

  const headerRow = (
    <thead>
      <tr className='thead-light'>
        {header &&
          header.columns.map((c, columnIndex) => {
            return <th key={`${id}-0-${columnIndex}`}>{c}</th>;
          })}
      </tr>
    </thead>
  );

  const dataRow = (row: TableRow, rowIndex: number) => {
    return (
      <tr key={`${id}-${rowIndex + 1}`}>
        {row.columns.map((c, columnIndex) => {
          const key = `${id}-${rowIndex + 1}-${columnIndex}`;

          if (isMidTitle(c)) {
            return (
              <td key={key} colSpan={c.colspan} className='mid-title'>
                {c.title}
              </td>
            );
          }

          return <td key={key}>{c}</td>;
        })}
      </tr>
    );
  };

  const body = <tbody>{rows.map((r, rowIndex) => dataRow(r, rowIndex))}</tbody>;

  return (
    <div id={id} className='table-widget'>
      {title && <h2>{title}</h2>}
      <table>
        {header && headerRow}
        {body}
      </table>
      {addendum && (
        <p data-testid='addendum' className='addendum'>
          {addendum}
        </p>
      )}
    </div>
  );
};

export default Table;
